






















import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const ApplicationStore = namespace('application');

@Component({})
export default class InvalidTokenDialogComponent extends Vue {

    @ApplicationStore.Getter('invalidTokenDialog')
    private _invalidTokenDialog!: boolean;

    @ApplicationStore.Mutation('setInvalidTokenDialog')
    private setInvalidTokenDialog!: (value: boolean) => void;

    @ApplicationStore.Mutation('setUsingCode')
    private setUsingCode!: (value: boolean) => void;

    get invalidTokenDialog(): boolean {
        return this._invalidTokenDialog;
    }

    set invalidTokenDialog(value: boolean) {
        this.setInvalidTokenDialog(value);
    }

    public onConfirm() {
        this.setInvalidTokenDialog(false);
        this.setUsingCode(false);
        this.$router.push({ name: 'code_view' });
    }
}
